import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { completeLogin } from "./oauthClient";
import { storeRefreshToken, storeToken } from "./token";
import { useAuth } from "./OidcProvider";

// Lands on /oauth/callback after Nova OS redirects back from /oauth/authorize.
// Exchanges the code → token, stashes it, then routes to wherever the user
// originally was (or "/" if they came here cold).
export function OauthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { token, refreshToken, redirectTo } = await completeLogin(searchParams);
        if (cancelled) return;
        storeToken(token);
        if (refreshToken) storeRefreshToken(refreshToken);
        refresh();
        navigate(redirectTo, { replace: true });
      } catch (e) {
        if (cancelled) return;
        setError((e as Error).message);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [searchParams, navigate, refresh]);

  if (error) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="max-w-md text-center">
          <h1 className="mb-2 text-lg font-semibold text-red-600">Sign-in failed</h1>
          <p className="text-sm text-slate-500">{error}</p>
          <button
            onClick={() => navigate("/", { replace: true })}
            className="mt-4 text-xs px-3 py-1 rounded bg-blue-100 text-blue-600"
          >
            Try again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen items-center justify-center text-slate-500">
      Completing sign-in…
    </div>
  );
}
